import React, { useState } from "react";
import styles from "./Notification.module.scss";
import { BellFilled } from "@ant-design/icons";

const Notification = (props) => {
  const { data } = props;

  const [activeCategory, setActiveCategory] = useState("");

  const getCategoryNotifications = (category) => {
    if (!category) return data;
    return data.filter((n) => n.status === category);
  };

  const handleSetCategory = (category) => {
    setActiveCategory(category);
  };

  return (
    <div className={styles.main}>
      <div className={styles.main_categories}>
        {categories.map(({ label, id }) => (
          <div
            key={id}
            className={
              id === activeCategory
                ? styles.main_categories_category
                : styles.main_categories_inactive
            }
            onClick={() => handleSetCategory(id)}
          >
            {label} ({getCategoryNotifications(id).length})
          </div>
        ))}
      </div>

      <div className={styles.main_lists}>
        {getCategoryNotifications(activeCategory).map(
          ({ id, title, subTitle, unread }) => (
            <div key={id}>
              <div className={styles.main_lists_date}>
                Recieved on May 02 2023
              </div>
              <div className={styles.main_lists_container}>
                <div className={styles.main_lists_container_icon}>
                  <BellFilled style={{ color: "#950303", fontSize: 28 }} />
                </div>
                <div>
                  <p>{title}</p>
                  <p>{subTitle}</p>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const categories = [
  {
    id: "",
    label: "All Notifications",
  },
  {
    id: "1",
    label: "Read",
  },
  {
    id: "0",
    label: "Unread",
  },
];

export default Notification;
